import { get } from 'lodash/fp'
import { Selector } from '../types/common'
import { ISpecies } from './speciesActions'

export const speciesSelector: Selector<ISpecies[]> = get('species.species')
